import { ProductBackendName } from "./productTypes";

export const HEALTH_PRICE_URL = "/open/insurance/health/price/";
export const LIFE_PRICE_URL = "/open/insurance/life/price/";
export const RISK_PRICE_URL = "/open/insurance/risk/price/";
export const ANIMAL_NEW_ENDPOINT = "dogcat";

export const BackendProductInfo = {
  ACCIDENT: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.ACCIDENT}`,
  },
  ADVICE: {
    priceReqUrl: "",
  },
  AKA_CRITICAL_ILLNESS: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.AKA_CRITICAL_ILLNESS}`,
  },
  AKA_FAMILY_ACCIDENT: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.AKA_FAMILY_ACCIDENT}`,
  },
  AKA_HEALTH: {
    priceReqUrl: `${HEALTH_PRICE_URL}${ProductBackendName.AKA_HEALTH}`,
  },
  AKA_HOUSE_CONTENTS: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.AKA_HOUSE_CONTENTS}`,
  },
  AKA_GROUP_LIFE: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.AKA_GROUP_LIFE}`,
  },
  AKA_TRAVEL: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.AKA_TRAVEL}`,
  },
  AKA_STUDENT: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.AKA_STUDENT}`,
  },
  BOAT: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.BOAT}`,
  },
  CAR: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.CAR}`,
  },
  CARAVAN: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.CARAVAN}`,
  },
  CHILD: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.CHILD}`,
  },
  CHILD_HEALTH: {
    priceReqUrl: `${HEALTH_PRICE_URL}${ProductBackendName.CHILD_HEALTH}`,
  },
  AKA_CHILD: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.AKA_CHILD}`,
  },
  ANIMAL: {
    priceReqUrl: `${RISK_PRICE_URL}${ANIMAL_NEW_ENDPOINT}`,
  },
  CABIN: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.CABIN}`,
  },
  CABIN_CONTENTS: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.CABIN_CONTENTS}`,
  },
  CRITICAL_ILLNESS: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.CRITICAL_ILLNESS}`,
  },
  DEATH: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.DEATH}`,
  },
  DISABILITY: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.DISABILITY}`,
  },
  ELECTRIC_SCOOTER: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.ELECTRIC_SCOOTER}`,
  },
  HEALTH: {
    priceReqUrl: `${HEALTH_PRICE_URL}${ProductBackendName.HEALTH}`,
  },
  HOUSE: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.HOUSE}`,
  },
  HOUSE_CONTENTS: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.HOUSE_CONTENTS}`,
  },
  HUSEIERNE_HOUSE_CONTENTS: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.HUSEIERNE_HOUSE_CONTENTS}`,
  },
  MOPED: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.MOPED}`,
  },
  MOTORCYCLE: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.MOTORCYCLE}`,
  },
  PREGNANT_AND_NEWBORN: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.PREGNANT_AND_NEWBORN}`,
  },
  RENTAL: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.RENTAL}`,
  },
  SOP_SICKNESS_LEAVE: {
    priceReqUrl: `${LIFE_PRICE_URL}${ProductBackendName.SOP_SICKNESS_LEAVE}`,
  },
  TRACTOR: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.TRACTOR}`,
  },
  TRAILER: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.TRAILER}`,
  },
  TRAVEL: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.TRAVEL}`,
  },
  VALUABLES: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.VALUABLES}`,
  },
  VETERAN_AUTO: {
    priceReqUrl: `${RISK_PRICE_URL}${ProductBackendName.VETERAN_AUTO}`,
  },
};

export const MAX_AGE_HEALTH_INSURANCE_CUSTOMER = 67;
export const MAX_AGE_AKA_HEALTH_INSURANCE_CUSTOMER = 70;
export const MIN_AGE_AKA_HEALTH_INSURANCE_CUSTOMER = 18;
export const MIN_AGE_HEALTH_INSURANCE_CUSTOMER = 18;
export const MAX_AGE_AKA_FAMILY_ACCIDENT_INSURANCE_CUSTOMER = 75;
export const MIN_AGE_AKA_FAMILY_ACCIDENT_INSURANCE_CUSTOMER = 18;
export const MAX_AGE_AKA_STUDENT_INSURANCE_CUSTOMER = 34;
export const MIN_AGE_AKA_STUDENT_INSURANCE_CUSTOMER = 18;
